import { createContext, useContext } from 'react'
import type { ZodTypeAny } from 'zod'

/** Minimal structural type covering ZodObject's shape accessors. */
type ZodObjectLike = ZodTypeAny & {
  shape?: Record<string, ZodTypeAny>
  _def?: { shape?: () => Record<string, ZodTypeAny> }
}

/** Exposes the Zod schema shape so field components can read required status. */
export const FormSchemaContext = createContext<Record<
  string,
  ZodTypeAny
> | null>(null)

/** Returns true if the named field is non-optional in the nearest Form's Zod schema. */
export function useFieldRequired(name: string): boolean {
  const shape = useContext(FormSchemaContext)
  if (!shape || !(name in shape)) return false
  try {
    return !shape[name].isOptional()
  } catch {
    return false
  }
}

export function extractShape(
  schema: ZodTypeAny,
): Record<string, ZodTypeAny> | null {
  const zodObjectLike = schema as ZodObjectLike

  if (zodObjectLike.shape && typeof zodObjectLike.shape === 'object') {
    return zodObjectLike.shape
  }
  if (typeof zodObjectLike._def?.shape === 'function') {
    return zodObjectLike._def.shape()
  }
  return null
}
